var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{style:({'height': _vm.iframeHeight}),attrs:{"allow":"microphone; camera","width":"100%","src":_vm.zoomUrl(),"frameborder":"0","allowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }